module.exports = __webpack_public_path__ + "img/case_01_1.76d262bd.png";